export default "__VITE_ASSET__zsAZVVpp__"